
import { defineComponent } from "vue";

export default defineComponent({
    name: "WorkListSkeleton",
    data() {
        return {
            items: 4,
        };
    },
});
